import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings → Easeedesk → Reopen ticket.
 *
 * Perechile vechi: `settings/easeedesk/reopen_ticket`, `reopen_ticket_list`,
 * `add_reopen_ticket_settings`, `activate_reopen_ticket_settings`,
 * `reopen_ticket_on_reply_status`, `remove_reopen_ticket_settings`.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export interface ReopenRule {
  ID: number
  ticket_type: number
  type_name: string
  short_name: string
  color_identifier: string
  status: number
  status_name: string
  active: number
  reopen_on_reply: number
}

export interface ReopenOption {
  ID: number
  type_name?: string
  status_name?: string
}

export interface ReopenShell {
  title: string
  moduleUrl: string
  ticketTypes: { ID: number; type_name: string }[]
  statuses: { ID: number; status_name: string }[]
}

export function reopenShellQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'reopen_ticket'],
    queryFn: () => apiGet<ReopenShell>('/settings/easeedesk/reopen_ticket'),
  })
}

export function reopenListQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'reopen_ticket', 'list'],
    queryFn: () => apiGet<{ settings: ReopenRule[] }>('/settings/easeedesk/reopen_ticket/list'),
  })
}

/**
 * Starile tipului ales, din fluxul lui - `get_ticket_type_status`, cerut de
 * vechea fereastra la fiecare schimbare a tipului. `statuses` din cap sunt
 * starile implicite ale furnizorului, nu ale tipului.
 */
export function reopenTypeStatusesQuery(type: number) {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'reopen_ticket', 'type_statuses', type],
    queryFn: () =>
      apiGet<{ statuses: { ID: number; status_name: string }[] }>(
        `/settings/easeedesk/reopen_ticket/types/${type}/statuses`,
      ),
    enabled: type > 0,
  })
}

export function createReopenRule(ticket_type: number, ticket_status: number, reopen_on_reply: boolean) {
  return apiPost<{ ok?: boolean; ID?: number }>('/settings/easeedesk/reopen_ticket', {
    ticket_type,
    ticket_status,
    reopen_on_reply: reopen_on_reply ? 'on' : 'off',
  })
}

export function changeReopenRuleStatus(rule: number, on: boolean) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/reopen_ticket/${rule}/status`, {
    active: on ? 'on' : 'off',
  })
}

export function changeReopenOnReply(rule: number, on: boolean) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/reopen_ticket/${rule}/on_reply`, {
    status: on ? 'true' : 'false',
  })
}

export function removeReopenRule(rule: number) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/reopen_ticket/${rule}/remove`, {})
}
